import {
  DataBlockFieldDto,
  DataType,
  MeasurementMappingDto,
} from '@lmt/shared-types';
import { MeasuredValue } from '@lmt/unicorn-shared/app/features/measurements/types';
import { formulaPrefix, calculateFormula } from './calculation';
import {
  parseDate,
  isTimeOnlyUnit,
  parseTime,
  fixedStringPrefix,
  parseFixedString,
} from './parsing';
import { localizeDataType } from '../../measurement-fields/common';

export function mapMeasuredValues(
  measuredValues: MeasuredValue[],
  mappings: MeasurementMappingDto[],
  measurementFields: DataBlockFieldDto[],
): { [key: string]: string | number } {
  console.log('mapMeasuredValues started');

  const values: { [key: string]: string | number } = {};
  mappings
    .filter((mapping) => mapping.isActive)
    .forEach((mapping) => {
      const field = measurementFields.find(
        (field) => field.id === mapping.fieldId,
      );
      if (!field) {
        throw new Error(
          `Measurement field for ${mapping.sourceName} is not found.`,
        );
      }
      try {
        if (mapping.sourceName.startsWith(formulaPrefix)) {
          const formulaResult = calculateFormula(
            mapping.sourceName,
            measuredValues,
          );
          if (!formulaResult) {
            if (mapping.isMandatory) {
              throw new Error(
                `Some variables are not found for mandatory field '${field.name}'`,
              );
            }
          } else {
            values[field.name] = formulaResult;
          }
          return;
        }
        if (mapping.sourceName.startsWith(fixedStringPrefix)) {
          values[field.name] = parseFixedString(mapping.sourceName);
          return;
        }
        const measuredValue = measuredValues.find(
          (value) => value.key === mapping.sourceName,
        );
        try {
          if (measuredValue && measuredValue.value) {
            if (
              field.dataType === DataType.DateTime ||
              field.dataType === DataType.DateOnly
            ) {
              if (isTimeOnlyUnit(measuredValue.unit)) {
                if (!mapping.ignoreErrors) {
                  throw new Error(
                    `Key ${mapping.sourceName} doesn't contain Date (${measuredValue.value}).`,
                  );
                } else {
                  console.log(
                    `Trying to parse TimeOnlyUnit (unit: '${
                      measuredValue.unit
                    }, value: '${measuredValue.value}' as ${
                      DataType[field.dataType]
                    })`,
                  );
                  return;
                }
              } else {
                values[field.name] = parseDate(
                  measuredValue.value,
                ).toISOString();
                return;
              }
            } else if (field.dataType === DataType.TimeOnly) {
              values[field.name] = parseTime(
                measuredValue.value,
                measuredValue.unit,
              )?.toString();
            } else if (field.dataType === DataType.Number) {
              values[field.name] = parseFloat(
                measuredValue.value.replace(',', '.'),
              );
            } else {
              values[field.name] = measuredValue.value.replaceAll('\\n', '\n');
            }
          } else if (mapping.isMandatory) {
            if (measuredValue && !measuredValue.value) {
              throw new Error(
                `Can't find value for mandatory field '${field.name}'`,
              );
            }
            throw new Error(`Key ${mapping.sourceName} is not found.`);
          }
        } catch (error) {
          console.error('Error mapping value:', measuredValue, error);
          throw new Error(
            `Error mapping field '${mapping.sourceName}' with value '${
              measuredValue?.value
            }' to ${localizeDataType(field.dataType)}. ${error}`,
          );
        }
      } catch (error) {
        console.error('field', field, 'mapping', mapping, error);
        if (!mapping.ignoreErrors) {
          if (!(error as any).message?.includes('Error mapping')) {
            throw new Error(
              `Error mapping field '${
                mapping.sourceName
              }'  to ${localizeDataType(field.dataType)}. ${error}`,
            );
          }
          throw error;
        }
      }
    });

  return values;
}
